import React from 'react';
import PropTypes from 'prop-types';

import { TableProvider } from './Table/TableContext';
import BaseTable from './Table/Table';

export default function Table(props) {
  return (
    <TableProvider>
      <BaseTable {...props} />
    </TableProvider>
  );
}

Table.propTypes = {
  props: PropTypes.object,
};

Table.defaultProps = {
  props: {},
};
